class PrinterConfig {
    constructor() {
        this.extruders = null;
    }
}

export default PrinterConfig;
